import { LanguagesEnum } from 'abi-opr-common-types';

import { OprAuthenticatedUser } from './types/session';

export class UserFactory {
  static createUserFromSession(user?: OprAuthenticatedUser) {
    return {
      name: user?.proxiedAs?.name ?? user?.name,
      zone: user?.proxiedAs?.zone ?? user?.zone,
      globalId: user?.proxiedAs?.globalId ?? user?.globalId,
      employeeId: user?.proxiedAs?.employeeId ?? user?.employeeId,
      roles: user?.proxiedAs?.role ?? user?.role,
      managedZones: user?.proxiedAs?.zones ?? user?.zones,
      language: user?.preferredLanguage as keyof typeof LanguagesEnum,
      isProxied: !!user?.proxiedAs,
      band: user?.proxiedAs?.band ?? user?.band,
      country: user?.proxiedAs?.country ?? user?.country,
      originalUser: {
        name: user?.name,
        zone: user?.zone,
        globalId: user?.globalId,
        employeeId: user?.employeeId,
        roles: user?.role,
        managedZones: user?.zones,
        band: user?.band,
        country: user?.country,
      },
    };
  }
}
